import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  public scrollControlDisabled = true;

  public searchFormGroup: FormGroup;
  public searchText = '';

  constructor(private router: Router, private location: Location) {
    this.searchFormGroup = new FormGroup({
      search: new FormControl()
    });

    this.searchFormGroup.get('search').valueChanges.subscribe((value: string) => {
      this.searchText = value;
      if (value.length > 0) {
        this.router.navigate(['/search', this.searchText]);
      } else {
        //this.location.back();
      }
    });
  }

  public onSearchSubmit() {}
}
